import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AccountContext } from 'components/AccountContext';
import Pagamento from '../../../../images/Pagamento.svg';
import { Box, Image, Text, VStack } from '@chakra-ui/react';
import ChildHeader from '../ChildHeader';
import { api } from 'api/api';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function PagamentoLocalizado(props) {
  const disclosure = props.disclosure;
  const { user, setUser, setPage, toastInadimplente } = useContext(AccountContext);
  setPage('Pagamento localizado');

  async function fetchClientImportadoContrato() {
    const response = await api(`${ENDPOINT}/clients/fetchClientImportadoContrato`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ cpf: user?.username }),
    });
    const resposta = await response.json();
    setUser((prevState) => ({
      ...prevState,
      qntdeParcelas: null,
      clienteImportado: false,
    }));
  }

  useEffect(() => {
    const fetchData = async () => {
      if (user?.clienteImportado?.clientImportado === true || user?.clienteImportado?.clientImportado === 'true') {
        await fetchClientImportadoContrato();
        return;
      }
      setUser((prevState) => ({ ...prevState, qntdeParcelas: null }));
    };

    fetchData();
  }, []);

  return (
    <>
      <ChildHeader />
      <Box display="flex" justifyContent="center" alignItems="center" w="100%" minHeight="50vh" flexDirection="column">
        <VStack w={'100%'} justifyContent="center" alignItems="center">
          <Box bg={'#F3F3F3'} w={'80%'} align={'center'} p={4} borderRadius={'0.8em'}>
            <Image src={Pagamento} alt="Pagamento" />
            <Text color={'#585858'} fontWeight={'bold'} fontSize={'20px'} mt={2}>
              Seu <span style={{ color: '#5AB2AE' }}>pagamento</span> foi <br /> realizado com <span style={{ color: '#5AB2AE' }}>sucesso</span>.
            </Text>
          </Box>
        </VStack>
      </Box>
    </>
  );
}

export default PagamentoLocalizado;
